// sentenceFactory.js
// Factory for creating the appropriate Sentence-derived instance
// based on context and optional override map.

import { Sentence, MyConversationSentence, ConversationSentence } from './Sentence';

/**
 * Create a Sentence-ish wrapper from content + phrase index.
 *
 * - Regular sentences: Sentence
 * - User conversations: MyConversationSentence
 * - Predefined conversations: ConversationSentence (placeholder for now)
 */
export function sentenceFactory(content, index, options = {}) {
  const phraseObj = content?.phrases?.[index] ?? null;
  if (!phraseObj) {
    // Return empty wrapper if index is invalid
    return new Sentence();
  }

  const phraseVal = phraseObj.phraseVal ?? {};
  const voices = phraseVal.voices ?? {};

  // No conversation_voice => regular sentence
  if (!('conversation_voice' in voices)) {
    return new Sentence(content, index, options);
  }

  // Has conv_canonical_id => predefined conversation sentence
  if ('conv_canonical_id' in phraseObj) {
    return new ConversationSentence(content, index, options);
  }

  // Otherwise: user-created conversation line
  return new MyConversationSentence(content, index, options);
}
